(function ($) {

    class ProductGallery extends HTMLElement {
        constructor() {
            super();
            this.options = {
                selectedTab: '',
                pernum: 6,  //展示6个缩略图
            };
            this.mainSwiper = null;
            this.fullscreenSwiper = null;
            // this.senseHandlerInstance = new SenseHandler();
            this.currentMediaId = '';
            this.previousMediaId = '';
            this.mediaTypeIdList = {
                features: [],
                video: [],
                options: []
            };
            // 存储不同类型的slider内容
            this.sliderContent = {
                features: '',
                video: ''
            };
            // 标记是否是变体变更触发的更新
            this.isVariantChange = false;
            this.mediaTypeList = [];
            this.mediaMap = new Map();
            if (this.classList.contains('product-gallery--autoinit')) {
               this.load();
            }
            this.bindEvent();
            this.initGalleryNode();
            this.fullscreenOpenStatus = false;
            this.trackStartedTime = null;
            this.canTrackPictureExposure = true;
        }

        get mainSwiperClass() {
            return 'product-gallery .product-media-gallery';
        }

        get fullscreenWrapperClass() {
            return 'product-gallery .product-gallery__fullscreen_slider';
        }


        initGalleryNode() {
            this.$gallery = $('[data-js-product-gallery]');
            this.$main_slider = this.$gallery.find('[data-js-product-gallery-main-slider]');
            this.$thumbnail_slider = this.$gallery.find('[data-js-product-gallery-thumbnail-slider]');
            this.$thumbnail_items = this.$thumbnail_slider.find('[data-js-product-gallery-thumbnail-item]');
            this.$thumbnail_arrow_prev = this.$gallery.find('[data-js-product-gallery-thumbnail-arrow-prev]');
            this.$thumbnail_arrow_next = this.$gallery.find('[data-js-product-gallery-thumbnail-arrow-next]');
            this.$fullscreen = $('.product-gallery__fullscreen');
            this.$fullscreenSlider = $('.product-gallery__fullscreen_slider');
            this.$fullscreenControl = this.$fullscreen.find('[data-js-product-gallery-control-fullscreen]');
        }

        load() {
            this.$gallery = $('[data-js-product-gallery]');
            var options_global = this.$gallery.find('[data-json-options-global]'),
                options_layout = this.$gallery.find('[data-json-options-layout]');

            options_global = options_global.length ? JSON.parse(options_global.html()) : {};
            options_layout = options_layout.length ? JSON.parse(options_layout.html()) : {};

            this.options = $.extend(true, {}, this.options, options_global, options_layout);
            let currentMediaId = this.options.media_id_index[0];
            this.initData();
            // 初始时保存不同类型的slider内容
            this.saveSliderContent();
            // 切换到当前选中类型的slider
            this.switchSliderContent('features');
            this.initMediaGallery();
            this.initGalleryNode();

            const queryParams = __Xtool_Utils.getQueryParams();
            if (!queryParams.variant || !this.options.current_variant.featured_media) return;
            currentMediaId = this.options.current_variant.featured_media.id;
            if (this.options.is_machine) {
                this.updateVariantFirstMedia(currentMediaId);
            } else {

                this.updateCurrentMediaId(currentMediaId);
            }
        }

        // 初始化媒体数据
        initData() {
            var list = [];
            this.mediaTypeIdList = {
                features: [],
                video: [],
                options: []
            };
            let tempMediaTypeIndex = 0;
            for (var i = 0 ; i < this.options.media_id_index.length; i++) {
                const mediaId = this.options.media_id_index[i];
                const $thumbnailItem = $(`[data-js-product-gallery-thumbnail-item][data-image-id=${mediaId}]`);
                const mediaType = $thumbnailItem.attr('data-item-media-type');

                let url = $thumbnailItem.find('img').attr('src');
                if (this.options.is_single_media) {
                    url = $('[data-js-product-gallery-main-single] img').attr('src');
                }
                
                const lastMediaType = list[i - 1]?.mediaType;

                if (!lastMediaType || lastMediaType !== mediaType) {
                    tempMediaTypeIndex = 0;
                } else {
                    tempMediaTypeIndex ++;
                }
                var data = {
                    mediaId: mediaId,
                    mediaType: mediaType,
                    mediaTypeIndex: tempMediaTypeIndex,
                    index: i,
                    url
                }
                list.push(data);
                this.mediaMap.set(mediaId, data);
                if (this.mediaTypeIdList[mediaType]) {
                    this.mediaTypeIdList[mediaType].push(mediaId);
                }
            }
            this.mediaList = list;
        }

        initMediaGallery() {
            var _ = this;
            
            const swiper = new Swiper(this.mainSwiperClass, {
                mousewheel: {
                    forceToAxis: true,
                    thresholdDelta: 10
                },
                loop: true,
                navigation: {
                    nextEl: `${this.mainSwiperClass} .product-media-gallery__button-next`,
                    prevEl: `${this.mainSwiperClass} .product-media-gallery__button-prev`,
                },
                autoplay: false,
                on: {
                    slideChange: function (a) {
                        if(!this.slides.length) {
                            return;
                        }
                        if (this.previousIndex && this.slides[this.previousIndex] && this.slides[this.previousIndex].dataset) {
                            const prevMediaId = this.slides[this.previousIndex].dataset.itemMediaId;
                            _.updatePreviousMediaId(prevMediaId);
                        }
                        const currentMediaId = this.slides[this.activeIndex]?.dataset?.itemMediaId;
                        _.updateCurrentMediaId(currentMediaId);
                     
                    }
                  }
            });
            this.mainSwiper = swiper;
            this.thumbnailSlider = $('[data-js-product-gallery-thumbnail-slider]');
        }

        // 保存不同类型的slider内容
        saveSliderContent() {
            const $swiperWrapper = $(`${this.mainSwiperClass} .swiper-wrapper`);
            const $allSlides = $swiperWrapper.find('.swiper-slide');
            
            // 创建图片和视频的轮播容器
            const $featuresSlides = $allSlides.filter(function() {
                return $(this).attr('data-item-media-type') !== 'video';
            }).clone();
            
            const $videoSlides = $allSlides.filter(function() {
                return $(this).attr('data-item-media-type') === 'video';
            }).clone();
            
            // 保存内容
            this.originalFeaturesSlides = $allSlides;
            this.sliderContent.features = $featuresSlides;
            this.sliderContent.video = $videoSlides;
        }
        
        // 切换slider内容
        switchSliderContent(type) {
            if( this.options.selectedTab === type) {
                return;
            }
            // // 如果swiper实例不存在，先初始化
            if (!this.mainSwiper) {
                // 获取swiper wrapper
                const $swiperWrapper = $(`${this.mainSwiperClass} .swiper-wrapper`);
                
                // 清空当前内容
                $swiperWrapper.empty();
                
                // 添加对应类型的内容
                if (type === 'video' && this.sliderContent.video.length > 0) {
                    $swiperWrapper.append(this.sliderContent.video);
                } else {
                    $swiperWrapper.append(this.sliderContent.features);
                }
                return;
            }
            this.options.selectedTab = type;
            // 移除所有幻灯片
            this.mainSwiper.removeAllSlides();
            // 准备新的幻灯片内容
            let newSlides = [];
            if (type === 'video' && this.sliderContent.video.length > 0) {
                this.sliderContent.video.each(function() {
                    newSlides.push($(this)[0]);
                });
            } else {
                this.sliderContent.features.each(function() {
                    newSlides.push($(this)[0]);
                });
            }
            
            // 添加新的幻灯片
            this.mainSwiper.appendSlide(newSlides);

            // 更新Swiper应用新设置
            this.mainSwiper.update();
            this.mainSwiper.slideToLoop(0, 0);
        }

        // 视频播放状态
        updateVideoPlayStatus() {
            const mediaInfo = this.mediaMap.get(+this.currentMediaId);
            const prevMediaInfo = this.mediaMap.get(+this.previousMediaId);  
            if (mediaInfo && mediaInfo.mediaType === 'video') {
                this.loadMedia(this.currentMediaId);
            }
            if (prevMediaInfo && prevMediaInfo.mediaType === 'video') {
                this.pauseMedia(this.previousMediaId);
            }
        }

        // 获取目标视频, 全屏、主图都可以调用
        getTargetVideo(id) {
            let targetClass = this.mainSwiperClass;
            if (this.fullscreenOpenStatus) {
                targetClass = this.fullscreenWrapperClass;
            }
            const $currentSwipperItem = $(targetClass).find(`[data-item-media-id=${id}]`);

            return $currentSwipperItem && $currentSwipperItem.find('video');
        }

        // 加载视频资源
        loadMedia(id) {
            const video = this.getTargetVideo(id);
            if (video && video.length) {
                const dataSrc = video.attr('data-src');
                const src = video.attr('src');
                if (!src && dataSrc) {
                    $(video).attr('src', dataSrc);
                }
                setTimeout(() => {
                    video.attr('autoplay', 'autoplay');
                    video.get(0).play();
                }, 10)
            }
        }
  
        // 暂停视频播放
        pauseMedia(id) {
            const video = this.getTargetVideo(id);
            if (video && video.length) {
                video.get(0).pause();
            }
        }

        getMediaIdByVariantId(variantId) {
            const variants = this.options.variants;
            const currentVariant = variants.find(variant => variant.id === variantId);
            return currentVariant && currentVariant.featured_media && currentVariant.featured_media.id;
        }

        // 绑定事件
        bindEvent() {
            const _ = this;
            // 点击分类事件
            $('.product-gallery__tabs').on('click', '.product-gallery__tabs_item', function () {
                const $this = $(this);
                const dataFilter = $this.attr('data-filter');
                let mediaId = null;
                if (dataFilter === _.options.selectedTab) {
                    return;
                }
                _.switchSliderContent(dataFilter);
                const currentTypeMediaIdList = _.mediaTypeIdList[dataFilter];
                if (currentTypeMediaIdList.length) {
                    mediaId = currentTypeMediaIdList[0];
                }
                if (dataFilter === 'video') {
                    _.trackGalleryClick(_.currentMediaId, 'video_button', '');
                }
                // 切换到对应类型的slider
                
                // if (mediaId) {
                //     setTimeout(() => {
                //         debugger;
                //         _.updateCurrentMediaId(mediaId, 0);
                //     }, 0);
                // }
            });

            // 缩略图点击事件
            this.$thumbnail_slider.on('click', '[data-js-product-gallery-thumbnail-item]', function(e) {
                const mediaId = e.currentTarget.dataset.imageId;
                _.trackGalleryClick(mediaId, 'small_picture', '');
                if(_.options.selectedTab != 'features') {
                    _.switchSliderContent("features");
                }
                _.updateCurrentMediaId(mediaId, 0);
            });

            if (window.innerWidth >= 1024) {
                // 主图点击事件
                this.$main_slider.on('click', (e) => {
                    const target = e.target;
                    if (target.closest('.product-media-gallery__button-next')) {
                        _.trackGalleryClick(_.previousMediaId, 'big_picture_switch_button', 'right');
                        return;
                    }
                    if (target.closest('.product-media-gallery__button-prev')) {
                        _.trackGalleryClick(_.previousMediaId, 'big_picture_switch_button', 'left');
                        return;
                    }
                    if (target.closest('.product-gallery__main_item--type-video')) return;
                    this.handleShowfullScreen();
                });

                // 关闭全屏
                this.$fullscreenControl.on('click', () => {
                    this.handleCloseFullscreen();
                })
            }

            // 监听产品页gallery，更新媒体id
            document.addEventListener('on::product::gallery::update', (e) => {
                if (e.detail.id) {
                    if (!this.options.is_machine) {
                        _.switchSliderContent('features');
                        _.updateCurrentMediaId(e.detail.id, 0);
                        return;
                    }
                    if(this.options.selectedTab === 'features') {
                        _.updateVariantFirstMedia(e.detail.id);
                    } else {
                        _.switchSliderContent('features');
                        setTimeout(() => {
                            _.updateVariantFirstMedia(e.detail.id);
                        }, 0);
                    }
                }
            })

            document.addEventListener('visibilitychange', function () {
                // 用户息屏、或者切到后台运行 （离开页面）
                if (document.visibilityState === 'hidden') {
                    _.trackPictureExposure(_.currentMediaId);
                }
                // 用户打开或回到页面
                if (document.visibilityState === 'visible') {
                    _.setTrackStartedTime();
                }
            })
            // 监听滚动
            $(window).on('scroll', theme.throttle((e) => {
                if (this.isGalleryInViewPort()) {
                    _.canTrackPictureExposure = true;
                    if (!_.trackStartedTime) {
                        _.setTrackStartedTime();
                    }
                } else {
                    _.trackPictureExposure(_.currentMediaId);
                    _.canTrackPictureExposure = false;
                    _.trackStartedTime = null;
                }
            }, 300));

            // 监听缩略图箭头点击事件
            this.currentPage = this.getCurPage();
            this.$thumbnail_arrow_prev.on('click', () => {
                _.trackGalleryClick(_.currentMediaId, 'small_picture_switch_button', 'left');
                this.handleThumbnailArrowClick('prev');
            });
            this.$thumbnail_arrow_next.on('click', () => {
                _.trackGalleryClick(_.currentMediaId, 'small_picture_switch_button', 'right');
                this.handleThumbnailArrowClick('next');
            });
            $('.product-page-get-gallery-video-button').on('click', () => {
                const currentTypeMediaIdList = _.mediaTypeIdList['video'];
                const mediaId = currentTypeMediaIdList[0];
                _.trackGalleryClick(_.currentMediaId, 'video_button', '');
                // 切换到对应类型的slider
                _.switchSliderContent('video');
                _.updateCurrentMediaId(mediaId, 0);
            })
        }

        // 缩略图箭头点击事件
        handleThumbnailArrowClick(direction) {
            if (direction === 'prev') {
                this.currentPage--;
            } else {
                this.currentPage++;
            }
            this.handleTransformThumbnail(true);
        }

        // 判断是否显示 save 标签
        handleIfBadgeShow() {
            const $badge = $(".product-badge_main");
            const hasInit = $badge.attr('data-has-init');
            if(!hasInit) return;
            const inventoryQuantity = $badge.attr("data-inventory-quantity");
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            const mediaType = currentMediaInfo && currentMediaInfo.mediaType;
            if (mediaType === 'options' || mediaType === 'features' && currentMediaInfo.mediaTypeIndex === 0) {
                if((inventoryQuantity <= 0 && $badge.find(".inventory-quantity").length)){
                    $badge.hide();
                }else {
                    document.dispatchEvent(new CustomEvent('setSaveAmount', {
                        detail: {
                            callback: () => {
                                $badge.css("display", "flex");
                            }
                        }
                    }));
                }
            } else {
                $badge.hide();
            }
        }

        updatePreviousMediaId(prevId) {
            if (prevId) {
                this.previousMediaId = +prevId;
            }
        }

        // 更新当前媒体id
        updateCurrentMediaId(id, speed) {
            if (+id === +this.currentMediaId) {
                return;
            }
            // 检查媒体ID是否存在
            if (!this.mediaMap.has(+id)) {
                return;
            }
            this.currentMediaId = +id;
            this.updateVideoPlayStatus();
            if (this.options.selectedTab != 'video') {
                // 通过id去切换大图
                this.goToSlideByActiveId(speed);
            }
            // 设置分类tab选中
            this.handleSetSelectTab();
            // 更新页码

            // 判断是否显示 save 标签
            this.handleIfBadgeShow();

            this.trackPictureExposure(this.previousMediaId);

            setTimeout(() => {
                this.handleUpdatePageNum();

                // 过滤缩略图分类图片
                this.handleFilterThumbnail();
                // 缩略图滑动
                this.handleTransformThumbnail();
                // 缩略图激活
                this.handleThumbnailActive();
                this.setTrackStartedTime();
                // 更新视频按钮状态
                this.updateVideoButtonStatus();
            }, 0)
        }

        // 通过id去切换大图
        goToSlideByActiveId(speed) {
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            if (currentMediaInfo && this.mainSwiper) {
                if (this.mainSwiper.realIndex === currentMediaInfo.index) {
                    return;
                }
                this.mainSwiper.slideToLoop(currentMediaInfo.index, speed);
            }
        }

        // 获取当前页
        getCurPage() {
            let mediaTypeIndex = 0;
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            if (currentMediaInfo && this.options.is_show_product_image_classify) {
                mediaTypeIndex = currentMediaInfo.mediaTypeIndex;
            } else {
                mediaTypeIndex = currentMediaInfo.index;
            }
            return Math.ceil((mediaTypeIndex + 1) / (this.options.pernum));
        }

        // 设置分类tab选中
        handleSetSelectTab() {
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            if (currentMediaInfo) {
                const mediaType = currentMediaInfo.mediaType;
                this.options.selectedTab = mediaType;
                $('.product-gallery__tabs').find('.product-gallery__tabs_item').removeClass('selected');
                $('.product-gallery__tabs').find(`[data-filter="${mediaType}"]`).addClass('selected');
            }
        }

        // 缩略图滑动
        handleTransformThumbnail(isPrev) {
            // 1. 设置滑动参数
            const sliderConfig = {
                normal: {
                    transform: 336, // 每个缩略图的宽度
                    padding: 38,    // 缩略图之间的间距
                },
            };
            
            // 2. 计算最大滑动距离
            const $thumbnailSlides = $('.product-gallery__thumbnail_slides');
            const slidesWidth = $thumbnailSlides.width();
            const maxTransform = Math.max(0, slidesWidth - sliderConfig.normal.transform);
            
            // 3. 获取当前显示的缩略图
            const filteredItems = this.options.is_show_product_image_classify 
                ? $(`[data-js-product-gallery-thumbnail-item].media-${window.innerWidth < 1024 ? this.options.selectedTab : 'features'}`)
                : $(`[data-js-product-gallery-thumbnail-item]`);
            
            // 4. 获取当前媒体信息
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            const isVideo = currentMediaInfo && currentMediaInfo.mediaType === 'video';
            
            // 如果是视频，不进行滑动
            if (isVideo && !isPrev) {
                return;
            }
            
            // 5. 计算总页数和当前页
            const totalPages = Math.ceil(filteredItems.length / this.options.pernum);
            const currentPage = Math.min(Math.max(isPrev ? this.currentPage : this.getCurPage(), 1), totalPages);
            
            // 6. 计算滑动距离
            const baseTransform = (currentPage - 1) * sliderConfig.normal.transform;
            const maxPageTransform = (totalPages - 1) * sliderConfig.normal.transform;
            const transformValue = Math.min(baseTransform, maxPageTransform, maxTransform);
            
            // 7. 应用滑动变换
            $thumbnailSlides.css('transform', `translate3d(-${transformValue}px, 0px, 0px)`);
            
            // 8. 控制箭头显示和状态
            const $prevArrow = this.$thumbnail_arrow_prev;
            const $nextArrow = this.$thumbnail_arrow_next;
            
            if (filteredItems.length > this.options.pernum) {
                // 显示箭头
                $prevArrow.removeClass('d-none-important');
                $nextArrow.removeClass('d-none-important');
                
                // 设置箭头状态
                const setArrowState = ($arrow, isDisabled) => {
                    $arrow.css({
                        'opacity': isDisabled ? 0.5 : 1,
                        'pointer-events': isDisabled ? 'none' : 'auto'
                    });
                };
                
                // 更新箭头状态
                setArrowState($prevArrow, currentPage === 1);
                setArrowState($nextArrow, currentPage === totalPages);
            } else {
                // 隐藏箭头
                $prevArrow.addClass('d-none-important');
                $nextArrow.addClass('d-none-important');
            }
            
            // 9. 更新当前页码
            this.currentPage = currentPage;
        }

        // 过滤缩略图分类图片
        handleFilterThumbnail() {
            var _ = this;
            if (this.$thumbnail_slider.hasClass('d-none-important')) {
                this.$thumbnail_slider.removeClass('d-none-important');
            }
            if (this.options.is_show_product_image_classify && window.innerWidth < 1024) {
                $('[data-js-product-gallery-thumbnail-item]').addClass('d-none-important');
                const filteredItems = $(`[data-js-product-gallery-thumbnail-item].media-${this.options.selectedTab}`);
                filteredItems.removeClass('d-none-important');
            }
            // 在PC端隐藏视频缩略图
            if (window.innerWidth >= 1024) {
                $('[data-js-product-gallery-thumbnail-item]').removeClass('d-none-important');
                $('[data-js-product-gallery-thumbnail-item].media-video').addClass('d-none-important');
            }
        }

        // 缩略图激活
        handleThumbnailActive() {
            $(`[data-js-product-gallery-thumbnail-item][data-image-id=${this.currentMediaId}]`).addClass('current').siblings().removeClass('current');
        }

        // 更新视频按钮状态
        updateVideoButtonStatus() {
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            const isVideo = currentMediaInfo && currentMediaInfo.mediaType === 'video';
            $('.product-page-get-gallery-video-button .video-button-wrapper').toggleClass('active', isVideo);
        }

        // 更新页码
        handleUpdatePageNum() {
            const $mainPaging = $('.product-gallery__main_paging');
            if (!$mainPaging.length) {
                return;
            }
            if ($mainPaging.hasClass('d-none')) {
                $mainPaging.removeClass('d-none');
            }
            const currentMediaInfo = this.mediaMap.get(this.currentMediaId);
            if (currentMediaInfo) {
                let index = 0;
                const currentType = currentMediaInfo.mediaType;
                const $curNum = $mainPaging.find('span.cur_num');
                const $totalNum = $mainPaging.find('span.total_num');
                let totalNum = 0;
                if (this.options.is_show_product_image_classify) {
                    totalNum = this.mediaTypeIdList[currentType].length;
                    index = currentMediaInfo.mediaTypeIndex;
                } else {
                    totalNum = this.mediaMap.size;
                    index = currentMediaInfo.index;
                }
                $curNum.html(+index + 1);
                $totalNum.html(totalNum);
                if (totalNum === 1) {
                    $('.product-media-gallery__button').addClass('d-none');
                } else {
                    $('.product-media-gallery__button').removeClass('d-none');
                }
            }
        }

        // 初始化全屏swiper
        initFullScreenSwipper() {
            if (this.$fullscreenSwiper) {
                this.$fullscreenSwiper.destroy(true, true);
                this.$fullscreenSwiper = null;
            }
            this.$fullscreen$fullscreen = $('.product-gallery__fullscreen');
            this.$fullscreenSlider = $('.product-gallery__fullscreen_slider');
            this.$fullscreenControl = this.$fullscreen.find('[data-js-product-gallery-control-fullscreen]');
                 
            // 复制主图内容到全屏
            const mainSwiperContent = $(this.mainSwiperClass).find('.swiper-wrapper').html();
            this.$fullscreenSlider.html(`<div class="swiper-wrapper">${mainSwiperContent}</div>`);

            // 初始化全屏swiper
            this.fullscreenSwiper = new Swiper(this.fullscreenWrapperClass, {
                loop: true,
                navigation: {
                    nextEl: '[data-js-product-gallery-fullscreen-arrow-next]',
                    prevEl: '[data-js-product-gallery-fullscreen-arrow-prev]',
                },
                on: {
                    slideChange: (swiper) => {
                        if (swiper.slides.length) {
                            const currentMediaId = swiper.slides[swiper.activeIndex].dataset.itemMediaId;
                            this.updateCurrentMediaId(currentMediaId, 300);
                        }
                    }
                }
            });
        }

        // 显示全屏
        handleShowfullScreen() {
            if (!this.fullscreenSwiper) {
                this.initFullScreenSwipper();
            }
            $body.addClass('product-gallery-fullscreen');
            this.$fullscreen.addClass('visible show');
            this.$fullscreen.find('.swiper-wrapper').addClass('mk-w-[100vh]');
            this.$fullscreenSlider.addClass('mk-w-[100vh]');
            this.$fullscreen.find('.product-gallery__main_item').css('width', '100vh');

            // 获取当前主图的索引
            const currentIndex = this.mainSwiper ? this.mainSwiper.activeIndex : 0;

            // 禁用body滚动
            document.body.style.overflow = 'hidden';
            // 同步当前滑动位置
            if (this.fullscreenSwiper) {
                this.fullscreenSwiper.slideTo(currentIndex, 0);
            }
            this.fullscreenOpenStatus = true;
        }

        // 关闭全屏
        handleCloseFullscreen() {
            const $body = $('body');
            
            // 移除全屏相关类名
            $body.removeClass('product-gallery-fullscreen');
            this.$fullscreen.removeClass('visible show');
            
            // 恢复body滚动
            document.body.style.overflow = '';
            this.fullscreenOpenStatus = false;
        }

        // gallery是否在视图里
        isGalleryInViewPort() {
            if (!this.$gallery.length) {
                return false;
            }
            const rect = this.$gallery.get(0).getBoundingClientRect();
            return rect.bottom >= __Xtool_Utils.getHeaderFixedHeight();
        }
        
        setTrackStartedTime(){
            this.trackStartedTime = Date.now();
        }

        trackPictureExposure(id) {
            if (!id || !this.canTrackPictureExposure) {
                return;
            }
            try {
                const currentMediaInfo = this.mediaMap.get(id);
                const variants = this.options.variants;
                let currentVariant = variants.find(variant => {
                    if (variant.featured_media) {
                        return variant.featured_media.id === id;
                    }
                    return false;
                });
                if (!currentVariant) {
                    const queryParams = __Xtool_Utils.getQueryParams();
                    if (queryParams.variant) {
                        currentVariant = variants.find(variant => variant.id === +queryParams.variant);
                    }
                }
                let sku = variants[0].sku;
                if (currentVariant) {
                    sku = currentVariant.sku;
                }
                if (currentMediaInfo) {
                    let picture_class = '';
                    if ( currentMediaInfo.mediaType) {
                        picture_class = currentMediaInfo.mediaType.charAt(0).toUpperCase() + currentMediaInfo.mediaType.slice(1);
                    }
                    const data = {
                        picture_pagecount: this.mediaMap.size,
                        picture_pagenumber: currentMediaInfo.index + 1,
                        picture_class,
                        picture_url: currentMediaInfo.url,
                        sku,
                        media_files: currentMediaInfo.mediaType
                    };

                    const startedTime = __Xtool_Utils.dateFormat(this.trackStartedTime, 'YYYY-MM-DD HH:mm:ss');
                    const endedTime = __Xtool_Utils.dateFormat(Date.now(), 'YYYY-MM-DD HH:mm:ss');
                    const exposureTime = this.getExposureTime();

                    if (SenseBlock.track) {
                        SenseBlock.track('PictureExposure', {
                            ...data,
                            strated_time: startedTime,
                            finished_time: endedTime
                        });
                    }
                    if (SenseBlock.gtmTrack) {
                        SenseBlock.gtmTrack('picture_exposure', {
                            ...data,
                            item_id: sku,
                            started_time: startedTime, 
                            finished_time: endedTime,
                            exposure_time: exposureTime,
                            product_title: this.options.product_title,
                            product_id: this.options.product_id
                        })
                    }
                }
            } catch (e) {
                console.error(e);
            }
        }

        trackGalleryClick(id, resource_location, switch_direction = '') {
            if (!id) {
                return;
            }
            const currentMediaInfo = this.mediaMap.get(+id);
            const picturePagenumber = currentMediaInfo.index + 1;
            const data = {
                resource_location: resource_location,
                picture_pagenumber: picturePagenumber,
                switch_direction: switch_direction,
                product_title: this.options.product_title,
                product_id: this.options.product_id,
                media_files: currentMediaInfo.mediaType
            }
            if (SenseBlock.gtmTrack) {
                SenseBlock.gtmTrack('click_actions_in_gallery', data);
            }
        }

        // 获取曝光时长
        getExposureTime() {
            // 计算总秒数
            const timeDiff = Date.now() - this.trackStartedTime;
            return Math.floor(timeDiff / 1000);
        }

        // 更新变体对应的第一张媒体图
        updateVariantFirstMedia(id) {
            if (!id || !this.options.options_media_objects) {
                return;
            }
            
            try {
                // 获取变体对应的媒体信息
                let mediaObj = null;
                
                // 从options_media_objects获取对应的媒体信息
                if (this.options.options_media_objects && Array.isArray(this.options.options_media_objects)) {
                    // 遍历数组查找匹配的媒体对象
                    mediaObj = this.options.options_media_objects.find(item => {
                        // 可能直接匹配ID或者ID作为字符串包含在某些属性中
                        return item.id == id || 
                               (item.variantId && item.variantId == id) || 
                               (item.key && item.key.includes(id));
                    });
                }
                
                // 如果找不到媒体信息，尝试从variants中查找
                if (!mediaObj && this.options.variants) {
                    const variant = this.options.variants.find(v => v.id == id);
                    if (variant && variant.featured_media && variant.featured_media.id) {
                        mediaObj = {
                            id: variant.featured_media.id,
                            src: variant.featured_image ? variant.featured_image.src : ''
                        };
                    }
                }
                
                if (mediaObj && mediaObj.id && mediaObj.src) {
                    const mediaId = mediaObj.id;
                    const mediaUrl = mediaObj.src || '';
                    
                    if(this.isVariantChange) {
                        // 1. 将媒体ID替换成options.media_id_index的第一个
                        this.options.media_id_index[0] = +mediaId;
                        
                        // 2. 更新缩略图中的第一张图
                        const $firstThumbnail = $('[data-js-product-gallery-thumbnail-item]').first();
                        
                        if ($firstThumbnail.length) {
                            $firstThumbnail.attr('data-image-id', mediaId);
                            
                            if (mediaUrl) {
                                // 处理缩略图中的picture和source元素
                                const $thumbnailPicture = $firstThumbnail.find('picture');
                                if ($thumbnailPicture.length) {
                                    $thumbnailPicture.find('source').each(function() {
                                        const srcset = $(this).attr('srcset');
                                        if (srcset) {
                                            $(this).attr('srcset', mediaUrl);
                                        }
                                    });
                                    
                                    $thumbnailPicture.find('img').attr('src', mediaUrl);
                                } else {
                                    // 如果没有picture元素，直接更新img
                                    $firstThumbnail.find('img').attr('src', mediaUrl);
                                }
                            }
                        }
                        
                        // 3. 更新mediaMap中的媒体对象
                        if (this.mediaMap.has(+mediaId)) {
                            // 如果媒体ID已存在于mediaMap中，更新其URL
                            const mediaData = this.mediaMap.get(+mediaId);
                            if (mediaUrl) {
                                mediaData.url = mediaUrl;
                            }
                        } else {
                            this.initData();
                        }
                        
                        // 5. 更新主图swiper
                        if (this.mainSwiper) {
                            // 创建新的slide HTML
                            const $template = $('<div class="swiper-slide media-features swiper-slide product-gallery__main_item product-gallery__main_item--type-image position-relative overflow-hidden"></div>');
                            $template.attr('data-item-media-id', mediaId);
                            $template.attr('data-item-media-type', 'features');
                            
                            // 添加图片内容
                            if (mediaUrl) {
                                const pictureHtml = `
                                    <div class="product-gallery__main_item_inner">
                                        <picture class="media-item__img product-gallery__main_image">
                                            <source srcset="${mediaUrl}">
                                            <img src="${mediaUrl}" data-src="${mediaUrl}" alt="Product Image">
                                        </picture>
                                    </div>
                                `;
                                $template.html(pictureHtml);
                            }
                            const slidesArray = this.sliderContent.features.toArray(); // 转为 DOM 元素数组
                            slidesArray[0] = ($template[0]); // 替换第一个元素
                            this.sliderContent.features = $(slidesArray);
                            
                            // 先强制滑动到第一张，确保状态稳定
                            this.mainSwiper.slideToLoop(0, 0);
                            
                            // 删除第一个slide
                            this.mainSwiper.removeSlide(0);
                            // 在0的位置添加新slide
                            this.mainSwiper.addSlide(0, $template[0]);
                            // 更新swiper
                            this.mainSwiper.update();
                            
                            // 再次滑动到第一张
                            this.mainSwiper.slideToLoop(0, 0);
                            // 有子域名时执行 transcy插件图片替换
                            if (Shopify.routes.root !== '/') {
                                // 立即执行 transcy插件图片替换,无延迟
                                if (_transcy && _transcy.methods && _transcy.methods.runReplaceImg) {
                                    _transcy.methods.runReplaceImg();
                                }
                            }

                        } else {
                            this.switchSliderContent('features');
                        }
                        
                        // 6. 更新全屏swiper
                        this.initFullScreenSwipper();
                        
                    } else {
                        // 在else部分创建新的第一个slider相关信息并添加到对应数据的第一位
                        
                        // 1. 将媒体ID替换成options.media_id_index的第一个
                        this.options.media_id_index.unshift(+mediaId);
                        
                        // 2. 创建新的缩略图
                        const $existingThumbnail = $('[data-js-product-gallery-thumbnail-item]').first();
                        if ($existingThumbnail.length) {
                            const $newThumbnail = $existingThumbnail.clone();
                            
                            // 设置新的id和图片
                            $newThumbnail.attr('data-image-id', mediaId);
                            
                            if (mediaUrl) {
                                const $thumbnailPicture = $newThumbnail.find('picture');
                                if ($thumbnailPicture.length) {
                                    $thumbnailPicture.find('source').each(function() {
                                        $(this).attr('srcset', mediaUrl);
                                    });
                                    
                                    $thumbnailPicture.find('img').attr('src', mediaUrl);
                                } else {
                                    $newThumbnail.find('img').attr('src', mediaUrl);
                                }
                            }
                            
                            // 将新缩略图放到第一位
                            $existingThumbnail.before($newThumbnail);
                            
                            // 重新设置所有缩略图的索引
                            const $allThumbnails = $('[data-js-product-gallery-thumbnail-item]');
                            $allThumbnails.each(function(index) {
                                $(this).attr('data-index', index);
                            });
                        }
                        
                        // 4. 更新媒体数据
                        this.initData();
                        // 3. 创建新的slide元素(直接操作DOM)
                        if (this.mainSwiper) {
                            // 创建新的slide HTML
                            const $template = $('<div class="swiper-slide media-features swiper-slide product-gallery__main_item product-gallery__main_item--type-image position-relative overflow-hidden"></div>');
                            $template.attr('data-item-media-id', mediaId);
                            $template.attr('data-item-media-type', 'features');
                            
                            // 添加图片内容
                            if (mediaUrl) {
                                const pictureHtml = `
                                    <div class="product-gallery__main_item_inner">
                                        <picture class="media-item__img product-gallery__main_image">
                                            <source srcset="${mediaUrl}">
                                            <img src="${mediaUrl}" data-src="${mediaUrl}" alt="Product Image">
                                        </picture>
                                    </div>
                                `;
                                $template.html(pictureHtml);
                            }
                            const slidesArray = this.sliderContent.features.toArray(); // 转为 DOM 元素数组
                            slidesArray.unshift($template[0]); // 在数组开头插入新元素
                            this.sliderContent.features = $(slidesArray);
                            // 使用swiper的API在前面添加新slide
                            this.mainSwiper.prependSlide($template[0]);
                            // 更新并滑动到第一张
                            this.mainSwiper.update();
                            this.mainSwiper.slideToLoop(0, 0);
                        }
                        
                        
                        
                        // 5. 重新初始化全屏swiper
                        this.initFullScreenSwipper();
                    }
                    
                    // 设置变体变更标志
                    this.isVariantChange = true;
                } else {
                    if(this.isVariantChange) {
                        $('[data-js-product-gallery-thumbnail-item]').first().remove();
                        // 重新获取DOM中剩余的缩略图
                        const $remainingThumbnails = $('[data-js-product-gallery-thumbnail-item]');
                        $remainingThumbnails.each(function(index) {
                            $(this).attr('data-index', index);
                        });
                        this.options.media_id_index.shift();
                        this.initData();
                        // 2. 恢复Swiper
                        if (this.mainSwiper) {
                            // 移除第一个slide(之前添加的变体图)
                            this.mainSwiper.removeSlide(0);
                            
                            // 恢复原始的slides内容
                            const slidesArray = this.sliderContent.features.toArray(); // 转为 DOM 元素数组
                            slidesArray.shift();
                            this.sliderContent.features = $(slidesArray);
                            
                            // 更新swiper
                            this.mainSwiper.update();
                            // 滑动到第一张
                            this.mainSwiper.slideToLoop(1, 0);
                            setTimeout(() => {
                                this.mainSwiper.slideToLoop(0, 300);
                            }, 0);
                            
                        }
                        this.isVariantChange = false;
                    }
                    
                }
            } catch (error) {
                console.error('更新变体媒体出错:', error);
            }
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('product-gallery', ProductGallery);
    });

    class DeliveryCountdown extends HTMLElement {
        constructor() {
            super();

            this.daysOfWeek = [
                theme.strings.delivery_countdown.days_of_week.sunday,
                theme.strings.delivery_countdown.days_of_week.monday,
                theme.strings.delivery_countdown.days_of_week.tuesday,
                theme.strings.delivery_countdown.days_of_week.wednesday,
                theme.strings.delivery_countdown.days_of_week.thursday,
                theme.strings.delivery_countdown.days_of_week.friday,
                theme.strings.delivery_countdown.days_of_week.saturday
            ];

            setTimeout(() => {
                this.elementCounter = this.querySelector('[data-js-delivery-countdown-counter]');
                this.elementDelivery = this.querySelector('[data-js-delivery-countdown-delivery]');

                this.deliveryTime = +this.dataset.deliveryTime;
                this.resetTime = +this.dataset.resetTime;
                this.deliveryFormat = this.dataset.deliveryFormat;
                this.excludes = this.dataset.deliveryExcludes.replace(/ /gi, '').toLowerCase().split(',');

                this.start();
            }, 0);
        }

        start() {
            this.display();
            this.interval = setInterval(() => this.display(), 1000);
        }

        display() {
            this.render(this.getRemainingTime());
        }

        getTotal() {
            return Date.parse(this.finalDate) - Date.parse(new Date());
        }

        getRemainingTime() {
            const now = new Date();

            this.finalDate = now;
            this.finalDate.setDate(this.finalDate.getDate() + 1);
            this.finalDate.setHours(this.resetTime, 0, 0, 0);

            const counterTotal = this.getTotal();
            const counterMinutes = Math.floor((counterTotal / 1000 / 60) % 60);
            const counterHours = Math.floor((counterTotal / (1000 * 60 * 60)) % 24);

            let finalyDeliveryTime = this.deliveryTime;
            let startExcludesDate = 0;

            // if (now.getHours() >= this.finalDate.getHours() && now.getMinutes() >= this.finalDate.getMinutes() && now.getSeconds() >= this.finalDate.getSeconds()) {
            //     finalyDeliveryTime++;
            //     startExcludesDate++;
            // }

            const deliveryDate = now;
            let endExcludesDate = this.deliveryTime + startExcludesDate + 1;

            for (let i = startExcludesDate; i < endExcludesDate; i++) {
                let currentDate = new Date();

                currentDate.setDate(currentDate.getDate() + i);

                if (this.excludes.indexOf(this.daysOfWeek[currentDate.getDay()].toLowerCase()) !== -1) {
                    deliveryDate.setDate(deliveryDate.getDate() + 1);
                    endExcludesDate++;
                }
            }

            deliveryDate.setDate(deliveryDate.getDate() + finalyDeliveryTime);

            return {
                counter: {
                    hours: counterHours,
                    minutes: counterMinutes
                },
                delivery: deliveryDate
            };
        }

        render(data) {
            const { counter, delivery } = data;
            let counterHTML = '';

            if (counter.hours) {
                counterHTML += `${counter.hours} ${theme.strings.delivery_countdown.hours.toLowerCase()} `;
            }

            counterHTML += `${counter.minutes} ${theme.strings.delivery_countdown.minutes.toLowerCase()}`;
            this.elementCounter.innerHTML = counterHTML;
            this.elementDelivery.innerHTML = this.deliveryFormat.toLowerCase()
                .replace('day', this.daysOfWeek[delivery.getDay()])
                .replace('dd', ('0' + delivery.getDate()).slice(-2))
                .replace('mm', ('0' + (delivery.getMonth() + 1)).slice(-2))
                .replace('yyyy', delivery.getFullYear())
                .replace('yy', delivery.getFullYear().toString().slice(-2));
        }

        disconnectedCallback() {
            if (this.inrerval) clearInterval(this.inrerval);
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('delivery-countdown', DeliveryCountdown);
    });

    // 暂不使用的功能
    // class VisitorsCounter extends HTMLElement {
    //     constructor() {
    //         super();
    //         this.load();
    //     }

    //     load() {
    //         this.counter = this.querySelector('[data-js-counter]');
    //         this.valueMin = this.dataset.min;
    //         this.valueMax = this.dataset.max;
    //         this.intervalMin = this.dataset.intervalMin;
    //         this.intervalMax = this.dataset.intervalMax;
    //         this.stroke = this.dataset.stroke;

    //         this.interval = setInterval(() => {
    //             this.update();
    //         }, this.randomInteger(this.intervalMin, this.intervalMax) * 1000);
    //     }

    //     update() {
    //         this.getNewValue();
    //         this.render();
    //     }

    //     render() {
    //         this.counter.innerHTML = this.currentValue;
    //     }

    //     getNewValue() {
    //         const currentValue = this.counter.text;
    //         const newValue = this.randomInteger(this.valueMin, this.valueMax);

    //         if(Math.abs(currentValue - newValue) > this.stroke) {
    //             newValue = newValue > currentValue ? currentValue + this.stroke : currentValue - this.stroke;
    //             newValue = this.randomInteger(currentValue, newValue);
    //         }

    //         this.currentValue = newValue;
    //     }

    //     randomInteger(min, max) {
    //         return Math.round(min - 0.5 + Math.random() * (max - min + 1));
    //     }

    //     disconnectedCallback() {
    //         clearInterval(this.interval);
    //     }
    // }

    // theme.AssetsLoader.onPageLoaded(function() {
    //     customElements.define('visitors-counter', VisitorsCounter);
    // });

    class SingleProduct extends HTMLElement {
        constructor() {
            super();

            setTimeout(() => {
                this.update();
            }, 0);
        }

        update() {
            if (theme.isLoaded) {
                theme.StoreLists.checkProductStatus(this);
            }
            theme.dynamicCheckout.load(this);
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('single-product', SingleProduct);
        theme.AssetsLoader.require('scripts', 'mkt_component_description');
    });

    class CrowdProcess extends HTMLElement {
        constructor() {
            super();
            this.init();
        }
        init() {
            var fetch_freq = Number(this.dataset.freq) || 10000;
            this.target_number = Number(this.dataset.goal) || 1000;
            if (!this.target_number || !fetch_freq) {
                return;
            }
            var crowdSectionEl = $("#crowd-progress-section");
            this.progressBarEl = crowdSectionEl.find(".progress-bar");
            this.progressGoalEl = crowdSectionEl.find(".crowd-progress-goal");
            this.backerNumberEl = crowdSectionEl.find(".backer-number");
            // 加载初执行一次
            this.fetchCrowdData();
            var that = this;

            var deadline = Number(this.dataset.deadline);
            var interval = setInterval(function () {
                // 截止时间，停止拉取数据
                var timeLeft = (new Date(deadline) - new Date()) / 1000;
                if (timeLeft <= 0) {
                    clearInterval(interval);
                }
                that.fetchCrowdData();
            }, fetch_freq);
        }
        renderView(data) {
            var current_value = data.customers || 0; // todo 0, 750, 1501, 3000
            var current_backers = data.customers || 0; // todo 0, n
            var current_percent = Math.round(current_value * 100 / this.target_number);
            var target_ratio_percent = Math.min(Math.round(this.target_number * 100 / current_value), 100);

            this.progressBarEl.css("width", Math.min(current_percent, 100) + "%")
                .attr("aria-now", current_value)
                .find(".progress-info").text(current_percent + "%");
            this.progressGoalEl.css("width", target_ratio_percent + "%");

            this.backerNumberEl.text(current_backers + ' Backers');
        }
        fetchCrowdData() {
            var that = this;
            $.get("https://dtc.mblock.cc/shopify/f1/saleInfo", function (data) {
                that.progressGoalEl.removeClass('progress-loading');
                // 缓存成功数据，用于失败时取用
                if (data && data.message === 'ok' && data.data) {
                    that.renderView(data.data);
                    localStorage.setItem('crowd_latest_data', JSON.stringify(data.data));
                } else {
                    var crowd_latest_data = localStorage.getItem('crowd_latest_data');
                    try {
                        that.renderView(crowd_latest_data ? JSON.parse(crowd_latest_data) : {});
                    } catch (err) {
                        console.error(err);
                    }
                }
            }).fail(function () {
                var crowd_latest_data = localStorage.getItem('crowd_latest_data');
                try {
                    that.renderView(crowd_latest_data ? JSON.parse(crowd_latest_data) : {});
                } catch (err) {
                    console.error(err);
                }
            })
        }
    }
    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('crowd-process', CrowdProcess);
    });

    class Product {
        constructor() {
            this.init();
            this.bindEvent();
        }
        init() {
            const $reviews = $('.product-page-info__reviews');
            if (!$reviews.length) {
                return;
            }
            const observer = new MutationObserver(function () {
                const $rating = $reviews.find('.jdgm-prev-badge');
                if (!$rating.length) {
                    return
                }
                const rating = $rating.attr('data-average-rating');
                if (rating != '0.00') {
                    $reviews.removeClass('d-none');
                    observer.disconnect();
                }
            });
            observer.observe($reviews.get(0), { subtree: true, childList: true });
        }
        /**
         * 绑定事件
         */
        bindEvent() {

            // 打开one+弹窗
            $('.open-tanchuang-popup').css('cursor', 'pointer');
            $('.open-tanchuang-popup').click(() => {
                //$(".proof-factor-cb-trigger-float-circle").click();
                $('.proof-factor-fw-triggers-floatbutton-circle').click();
            });
        }
    }

    class GraphqlHelper {
        constructor() {
            const storeName = window?.makeblock?.shop?.store_name || 'makeblock-xtool';
            const permanentDomain = window?.makeblock?.shop?.permanent_domain || 'makeblock-xtool.myshopify.com';
            const tokenConfig = {
                'makeblock-xtool': '7bb184c4d18313c58d0ccd6bfa0f73a3',
                'eu-xtool': '0886b237162c21d11ba1ca30f6220c6f',
                'uk-xtool': 'adf825795f70225d0351ad387d538757',
                'de-xtool': '87e1adaeba390a0b21e5ef6937792d2f',
                'fr-xtool': 'e397fc547281c76d1086776fa347d804',
                'jp-xtool': 'c9738498306280b6ae87bb999811d952',
                'ca-xtool': '7912e607574a3a6eaffaf501c75408e6',
                'xtool-australia-store': 'fabb70f52384af557b4ac0392f86c2ed',
                'wholesale-xtool-test': '8fc8c66d4b4ef6f972b8baf6674e07a3',

            }
            this.apiUrl = `https://${permanentDomain}/api/2023-01/graphql.json`;
            this.authHeaders = { 'x-shopify-storefront-access-token': tokenConfig[storeName] };
        }
        /**
         * 查询请求
         * @param { string } query  query 参数
         * @param { json } variables 变量
         */
        query(query, variables) {
            return fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    ...this.authHeaders,
                },
                body: JSON.stringify({ query, variables }),
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw { message: `${response.status}: ${response.statusText}` };
                    }
                })
                .catch((err) => {
                    return err.message;
                });
        }
    }

    const graphqlHelperInstance = new GraphqlHelper();
    // class Policy {
    //     constructor() {
    //         let $policyContent;
    //         if ($(window).width() <= 1024) {
    //             $policyContent = $('.hide-in-pc .p-policy-content');
    //         } else {
    //             $policyContent = $('.hide-in-h5 .p-policy-content');
    //         }
    //         const $policyList = $policyContent.find('.p-policy-list');
    //         const policyIds = JSON.parse($policyContent.attr('data-policy') || '[]');
    //         if (policyIds.length == 0) {
    //             if($(window).width() <= 1024){
    //                 $('.product-trust-tag').find('.checkout').addClass('haspadding');
    //             }
    //             return;
    //         }
    //         this.fetchMetaObjectInfo(policyIds).then((res) => {
    //             const list = res.data.nodes.map((item) => {
    //                 let listItem = {
    //                     label: item.fields[0].value,
    //                     svg_icon: item.fields[1].value,
    //                 };
    //                 return listItem;
    //             });
    //             list.map(({ label, svg_icon }) => {
    //                 $policyList.append(`
    //                     <div class="item">
    //                         <div class="word">
    //                             ${svg_icon}
    //                             <span>${label}</span>
    //                         </div>
    //                     </div>
    //                 `);
    //             });
    //             if (list.length > 0) {
    //                 $policyContent.removeClass('d-none');
    //                 if (list.length == 2) {
    //                     $policyList.addClass('two');
    //                 }
    //             }
    //         });
    //     }
    //     async fetchMetaObjectInfo(ids) {
    //         const query = `query($ids: [ID!]!) {
    //               nodes(ids: $ids) {
    //                 ... on Metaobject {
    //                   id
    //                   type
    //                   fields {
    //                     key
    //                     value
    //                   }
    //                 }
    //               }
    //             }
    //         `;
    //         const variables = `{
    //           "ids": ${JSON.stringify(ids)}
    //         }`;
    //         const result = await graphqlHelperInstance.query(query, variables);
    //         return result;
    //     };
    // }

   
    function onlyLabel() {
        $('.product-page__package-variant .disabled-hidden').each(function() {
            const displayBlock = $(this).css('display') === 'block';
            const topLabel = $(this).siblings('.product-page__package-variant_top_label');
            
            if (displayBlock && topLabel.length > 0) {
                topLabel.addClass('d-none');
            } else {
                topLabel.removeClass('d-none');
            }
        });
    }


    function getLabelHtml(varaint, type) {
        const varaintLabelMetafield = varaint.metafield;
        const quantityAvailable = varaint.quantityAvailable;
        const availableForSale = varaint.availableForSale;
        const variantId = varaint.id;
      
        const references = varaintLabelMetafield ? varaintLabelMetafield.references.edges : [];
        
        // 获取产品类型以判断是否为耗材
        const productType = varaint.product.productType;
        
        let labelItems = [];
        let enableVariantTag = false;
        // 获取全局开关状态和排除列表
        if(type === 'package') {
            enableVariantTag = window.makeblock.themeSettings.enableVariantTag;
        } else if(type === 'fbt') {
            enableVariantTag = window.makeblock.themeSettings.fbtEnableVariantTag;
        } else if(type === 'recommend_care') {
            enableVariantTag = window.makeblock.themeSettings.recommendCareEnableVariantTag;
        }
        const excludeVariantIds = window.makeblock.themeSettings.variantTagExcludeIds.split(',').map(id => id.trim());
        const isVariantExcluded = excludeVariantIds.includes(String(variantId));

        // 如果数量为0，则只展示预购和缺货标签
        if (quantityAvailable <= 0) {
            const preOrderLabel = __Xtool_Utils.t('products.package_label.pre-order') || 'Pre Order';
            const outOfStockLabel = __Xtool_Utils.t('products.package_label.out-of-stock') || 'Out of Stock';
            if (availableForSale) {
                labelItems.push(`<span class="product-get-options-package-data-label-list__item style-5">${preOrderLabel}</span>`);
            } else {
                labelItems.push(`<span class="product-get-options-package-data-label-list__item style-4">${outOfStockLabel}</span>`);
            }
        } else {
            // 检查是否应该显示全局Money Off标签（移除 show_promotion_info 判断）
            const shouldShowGlobalOffLabel = enableVariantTag && !isVariantExcluded;
            
            // 处理全局Money Off标签
            if (shouldShowGlobalOffLabel) {
                // 使用工具函数获取 off 标签模板（传 null 返回带 {{money}} 占位符的模板）
                // 后续会在 renderVariantLabel 中替换为实际金额
                const offLabel = __Xtool_Utils.getOffLabelText(productType, null);
                labelItems.push(`<span class="product-get-options-package-data-label-list__item style-1">${offLabel}</span>`);
            }

            references.forEach(v => {
                
                const fields = v.node.fields;
                const fieldName = fields.find(field => field.key === 'name');
                const fieldTxt = fields.find(field => field.key === 'txt');
                const labelText = fieldTxt ? fieldTxt.value : fieldName.value;
            
                // 根据标签名称确定样式类
                let styleClass = 'style-1';
                const name = fieldName.value;
                
                if (name.includes('Off')) {
                    styleClass = 'style-1';
                } else if (['Bestseller', 'Top Pick', 'Recommended', 'Free Gift'].includes(name)) {
                    styleClass = 'style-2';
                } else if (['Budget Friendly', 'Entry Level', 'Wood Working', 'T-shirt Making', 'Lease-to-own'].includes(name)) {
                    styleClass = 'style-3';
                } else if (name === 'Out of Stock') {
                    styleClass = 'style-4';
                } else if (name === 'Pre Order') {
                    styleClass = 'style-5';
                }
                
                // 处理Off标签
                if (name.includes('Off')) {
                    // 如果已经显示了全局Off标签，跳过所有手动Off标签
                    if (shouldShowGlobalOffLabel) {
                        return;
                    }
                    
                    // 如果变体在排除列表中，跳过显示
                    if (isVariantExcluded) {
                        return;
                    }
                    
                    // 使用工具函数获取 off 标签模板（传 null 返回带 {{money}} 占位符的模板）
                    // 如果是耗材，返回耗材专用模板；否则返回配置的文案或默认模板
                    let finalLabelText = __Xtool_Utils.getOffLabelText(productType, null);
                    // 如果工具函数返回空，则使用原始配置的 labelText
                    if (!finalLabelText) {
                        finalLabelText = labelText;
                    }
                    
                    // 显示手动配置的Off标签
                    labelItems.push(`<span class="product-get-options-package-data-label-list__item ${styleClass}">${finalLabelText}</span>`);
                } else {
                    // 处理非Off标签
                    labelItems.push(`<span class="product-get-options-package-data-label-list__item ${styleClass}">${labelText}</span>`);
                }
            });
        }

        if (labelItems.length > 0) {
            return `<div class="product-get-options-package-data-label-list">${labelItems.join('')}</div>`;
        }
        return '';
    }

    function getLabelStyle() {
      return `.product-get-options-package-data-label-list {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                font-weight: 500;
                line-height: 18px;
                align-items: center;
                margin-bottom: 8px;
            }
            .product-get-options-package-data-label-list__item {
                font-family: 'Inter Tight', sans-serif;
                font-size: 12px;
                font-weight: 500;
                line-height: 16px;
                padding: 2px 4px;
                border-radius: 4px;
                max-width: 183px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .product-get-options-package-data-label-list__item.style-2 {
                background: #fef3c7;
                color: #934313;
            }
            .product-get-options-package-data-label-list__item.style-1 {
                background: #f5222d;
                color: #fff;
            }
            .product-get-options-package-data-label-list__item.style-3 {
                background: #cffafe;
                color: #175e75;
            }
            .product-get-options-package-data-label-list__item.style-4 {
                background: #ecedf0;
                color: var(---, rgba(0, 0, 0, 0.65));
            }
            .product-get-options-package-data-label-list__item.style-5 {
                background: #d1fae5;
                color: #145f46;
            }
            .product-get-options-package-data-label-list__item:nth-child(n+3) {
                display: none;
            }    
            `
    }

    async function getProductVariantsLabels(ids, type, withStyle) {
      const res = await getProductVariantsMetaobjects(ids);
      const variantInfoMap = new Map();
      (res.data || []).nodes.forEach((node, index) => {
        const id = ids[index];
        variantInfoMap.set(id, {
            ...node.metafield,
            html: getLabelHtml(node, type)
        });
      });
      return {
        variantInfoMap,
        style: withStyle ? getLabelStyle() : ''
      };
    }

    async function getProductVariantsMetaobjects(ids) {
        // 处理变体ID：确保每个ID都有正确的Shopify前缀
        const VARIANT_ID_PREFIX = 'gid://shopify/ProductVariant/';
        const formattedIds = ids.map(id => {
            if (id.toString().startsWith(VARIANT_ID_PREFIX)) {
                return id;
            }
            return `${VARIANT_ID_PREFIX}${id}`;
        });
        
        const query = `
            query getVariantsWithMetaobjects($ids: [ID!]!) {
                nodes(ids: $ids) {
                    ... on ProductVariant {
                        id
                        quantityAvailable
                        availableForSale
                        product {
                            productType
                        }
                        metafield(namespace: "product", key: "package_variant_label") {
                            references(first: 10) {
                                edges {
                                    node {
                                        ... on Metaobject {
                                            handle
                                            fields {
                                                key
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `;

        const variables = {
          ids: formattedIds
        };
        const response = await GraphQLHelper.query(query, variables);
        return response;
    }


    /** 查询每个套餐购买一件时的买赠赠品，排除该套餐的货物清单赠品。 */
    class ProductPackageGifts {
        constructor() {
            this.requests = new Map();
            this.goodsLists = new Map();
            this.cards = new WeakMap();
            this.boundTriggers = new WeakSet();
            this.activeCard = null;

            document.addEventListener('theme:product::switchVariant', (event) => {
                this.update(event.detail?.$product?.[0] || document);
            });
            document.addEventListener('shopify:section:load', (event) => {
                this.update(event.target);
            });
            document.addEventListener('shopify:section:unload', (event) => {
                if (this.activeCard && event.target.contains(this.activeCard)) this.modal.close();
            });
            this.update(document);
        }

        update(root) {
            root.querySelectorAll('.product-page__package-variant').forEach((card) => {
                this.updateCard(card);
            });
        }

        async updateCard(card) {
            const $card = $(card);
            const trigger = card.querySelector('[data-package-gifts-open]');
            if (trigger && !this.boundTriggers.has(trigger)) {
                this.boundTriggers.add(trigger);
                trigger.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.open(card, trigger);
                });
            }
            const variantId = card.getAttribute('data-variant-id');
            const productId = card.getAttribute('data-product-id') || card.querySelector('[data-price-manager-product-id]')?.getAttribute('data-price-manager-product-id');
            const rawPrice = card.querySelector('[data-js-option-price]')?.getAttribute('data-js-option-price');
            if (!productId || !variantId || rawPrice == null || rawPrice === '' || !Number.isFinite(Number(rawPrice)) || Number(rawPrice) < 0) {
                this.cards.delete(card);
                $card.removeData('packageGiftCheck').removeData('packageFreeGifts').removeData('packageGiftItems');
                this.updateGiftSummary(card, []);
                return;
            }

            // Shopify 变体价格以分为单位；check 接口与购物车保持一致，传入金额字符串。
            const originalUnitPrice = (Number(rawPrice) / 100).toFixed(2);
            const countryCode = window.Shopify?.country || '';
            const customerId = window.makeblock?.customer?.id || '';
            const requestKey = JSON.stringify([productId, variantId, originalUnitPrice, countryCode, customerId]);
            const previous = this.cards.get(card);
            if (previous?.key === requestKey && previous.status !== 'error') return;

            const state = { key: requestKey, status: 'loading' };
            this.cards.set(card, state);
            $card.removeData('packageGiftCheck').removeData('packageFreeGifts').removeData('packageGiftItems');
            this.updateGiftSummary(card, []);

            try {
                if (!this.requests.has(requestKey)) {
                    // 每个变体独立计算，避免不同套餐在同一次请求中叠加命中买赠规则。
                    const body = {
                        scene: 'variant_free_gift',
                        line_items: [{
                            key: variantId,
                            variant_id: variantId,
                            quantity: 1,
                            original_unit_price: originalUnitPrice,
                        }],
                    };
                    if (countryCode) body.country_code = countryCode;

                    // Liquid 登录态为空时清除可能残留的身份头，与购物车 getFixSignatureHeader 一致。
                    const headers = customerId ? {} : {
                        'X-Mk-Shopify-Customer-ID': '',
                        'X-Mk-Shopify-Session-Token': '',
                        utoken: '',
                    };
                    const request = __Xtool_Utils.xccHttpV2('/customers/carts/check', {
                        method: 'POST',
                        headers,
                        body: JSON.stringify(body),
                    }).then((response) => {
                        if (response.code !== 0 || !Array.isArray(response.data?.free_gifts)) {
                            throw new Error(response.message || 'Invalid cart check response');
                        }
                        return response.data;
                    }).catch((error) => {
                        // 失败的请求允许后续变体切换时重试。
                        this.requests.delete(requestKey);
                        throw error;
                    });
                    // 相同变体、金额和用户上下文复用请求，也覆盖页面上的重复套餐卡片。
                    this.requests.set(requestKey, request);
                }

                const [data, goodsListGifts] = await Promise.all([
                    this.requests.get(requestKey),
                    this.getGoodsListGiftIds(productId),
                ]);
                if (this.cards.get(card) !== state || card.getAttribute('data-variant-id') !== variantId) return;

                const gifts = this.getGiftItems(data.free_gifts, goodsListGifts.get(variantId));
                state.status = 'ready';
                // 保留活动的 got、赠品的 line_item_key/type 等字段，供展示层判断赠品归属和解锁状态。
                $card.data('packageGiftCheck', data).data('packageFreeGifts', data.free_gifts).data('packageGiftItems', gifts);
                this.updateGiftSummary(card, gifts);
                card.dispatchEvent(new CustomEvent('theme:product::packageGiftsUpdated', {
                    bubbles: true,
                    detail: { variantId, quantity: 1, data, freeGifts: data.free_gifts, giftItems: gifts },
                }));
            } catch (error) {
                if (this.cards.get(card) !== state) return;
                state.status = 'error';
                console.error('[ProductPackageGifts] Failed to query gifts:', variantId, error);
            }
        }

        getGoodsListGiftIds(productId) {
            if (!this.goodsLists.has(productId)) {
                const request = __Xtool_Utils.getProductGoodsListInfo(productId).then((response) => {
                    if (response.code === 104355) return new Map();
                    if (response.code !== 0 || !Array.isArray(response.data?.goods) || !Array.isArray(response.data?.variants)) {
                        throw new Error(response.message || 'Invalid goods list response');
                    }
                    const giftGoods = new Map(response.data.goods
                        .filter((good) => good.is_gift === true)
                        .map((good) => [String(good.id), good]));
                    return new Map(response.data.variants.map((variant) => {
                        const ids = (variant.goods || []).map((good) => giftGoods.get(String(good.id))?.sh_variant_id)
                            .filter((id) => id != null && String(id).trim() !== '')
                            .map((id) => String(id).trim());
                        return [String(variant.sh_variant_id), new Set(ids)];
                    }));
                }).catch((error) => {
                    this.goodsLists.delete(productId);
                    throw error;
                });
                this.goodsLists.set(productId, request);
            }
            return this.goodsLists.get(productId);
        }

        getGiftItems(activities, excludedVariantIds = new Set()) {
            return (activities || []).flatMap((activity) => {
                return (activity.gifts || []).flatMap((gift) => {
                    // 礼品包只展示明细；普通赠品直接使用 gifts 自身的数据。
                    if (gift.variant_id === 0 || gift.variant_id === '0') {
                        return Array.isArray(gift.bundle_details) ? gift.bundle_details : [];
                    }
                    return [gift];
                });
            }).filter((gift) => {
                const variantId = gift.variant_id == null ? '' : String(gift.variant_id).trim();
                return variantId !== '' && !excludedVariantIds.has(variantId);
            });
        }

        updateGiftSummary(card, gifts) {
            const summary = card.querySelector('.product-package-gift-summary-box');
            if (summary) {
                summary.hidden = !gifts.length;
                const price = summary.querySelector('[data-package-gifts-price]');
                if (price) price.textContent = this.formatPrice(0);
                const worth = summary.querySelector('[data-package-gifts-worth]');
                if (worth) worth.textContent = this.formatPrice(Number(worth.dataset.packageGiftsWorth));
            }
            if (!gifts.length && this.activeCard === card) this.modal.close();
        }

        formatPrice(amount) {
            const options = { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' };
            if (amount === 0) {
                options.minimumFractionDigits = 0;
                options.maximumFractionDigits = 0;
            }
            return new Intl.NumberFormat(document.documentElement.lang || 'en', options).format(amount);
        }

        createModal() {
            const modal = document.createElement('dialog');
            modal.className = 'product-package-gifts-modal';
            modal.innerHTML = `
                <button type="button" class="product-package-gifts-modal__close">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
                        <circle cx="16" cy="16" r="14" fill="black"/>
                        <path d="m11 11 10 10m0-10L11 21" stroke="white" stroke-width="3" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="product-package-gifts-modal__body">
                    <ul class="product-package-gifts-modal__list list-unstyled"></ul>
                </div>`;
            modal.querySelector('.product-package-gifts-modal__close').addEventListener('click', () => modal.close());
            modal.addEventListener('click', (event) => {
                if (event.target !== modal) return;
                const rect = modal.getBoundingClientRect();
                if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
                    modal.close();
                }
            });
            modal.addEventListener('close', () => {
                if (!this.bodyWasScrollLocked) document.body.classList.remove('body-no-scroll');
                this.activeCard = null;
                if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
                if (this.scrollPosition && (window.scrollX !== this.scrollPosition.left || window.scrollY !== this.scrollPosition.top)) {
                    window.scrollTo({ ...this.scrollPosition, behavior: 'instant' });
                }
                this.returnFocus = null;
                this.scrollPosition = null;
            });
            document.body.appendChild(modal);
            this.modal = modal;
            return modal;
        }

        updateModalHeader(modal, card, trigger) {
            const variantTitle = card.querySelector('.product-page__package-variant__title')?.textContent.trim() || '';
            const modalTitle = (trigger.dataset.modalTitle || '').trim();
            const modalSubtitle = (trigger.dataset.modalSubtitle || '').replace('__variant__', variantTitle).trim();
            modal.querySelector('.product-package-gifts-modal__header')?.remove();
            modal.removeAttribute('aria-labelledby');
            modal.removeAttribute('aria-describedby');
            modal.setAttribute('aria-label', card.querySelector('.product-package-gift-summary__title')?.textContent.trim() || trigger.textContent.trim());
            if (!modalTitle && !modalSubtitle) return;

            const header = document.createElement('header');
            header.className = 'product-package-gifts-modal__header';
            if (modalTitle) {
                const title = document.createElement('h2');
                title.id = 'product-package-gifts-title';
                title.className = 'product-package-gifts-modal__title';
                title.textContent = modalTitle;
                header.appendChild(title);
                modal.removeAttribute('aria-label');
                modal.setAttribute('aria-labelledby', title.id);
            }
            if (modalSubtitle) {
                const subtitle = document.createElement('p');
                subtitle.id = 'product-package-gifts-subtitle';
                subtitle.className = 'product-package-gifts-modal__subtitle';
                subtitle.textContent = modalSubtitle;
                header.appendChild(subtitle);
                modal.setAttribute('aria-describedby', subtitle.id);
            }
            modal.prepend(header);
        }

        open(card, trigger) {
            if (this.cards.get(card)?.status !== 'ready') return;
            const gifts = $(card).data('packageGiftItems') || [];
            if (!gifts.length) return;

            const modal = this.modal || this.createModal();
            this.updateModalHeader(modal, card, trigger);
            modal.querySelector('.product-package-gifts-modal__close').setAttribute('aria-label', trigger.dataset.closeLabel);
            const list = modal.querySelector('.product-package-gifts-modal__list');
            const showWorth = trigger.dataset.worthInModal === 'true';
            list.replaceChildren(...gifts.map((gift) => this.createGiftRow(gift, showWorth)));

            this.activeCard = card;
            if (!modal.open) {
                this.scrollPosition = { left: window.scrollX, top: window.scrollY };
                this.returnFocus = trigger;
                this.bodyWasScrollLocked = document.body.classList.contains('body-no-scroll');
                trigger.focus({ preventScroll: true });
                modal.showModal();
                // 与货物清单对比弹窗一致，保留 html 的滚动容器，避免主图 sticky 定位失效。
                document.body.classList.add('body-no-scroll');
            }
        }

        createGiftRow(gift, showWorth = false) {
            const row = document.createElement('li');
            row.className = 'product-package-gifts-item';
            const image = document.createElement('img');
            image.className = 'product-package-gifts-item__image';
            image.width = 40;
            image.height = 40;
            image.alt = '';
            image.loading = 'lazy';
            // 仅接受图片 URL；接口文本均通过 textContent 写入。
            if (gift.img_url) {
                try {
                    const url = new URL(gift.img_url, window.location.href);
                    if (url.protocol === 'https:' || url.protocol === 'http:') image.src = url.href;
                } catch (error) {
                    // 缺少图片时保留固定尺寸的图片占位。
                }
            }
            image.addEventListener('error', () => { image.style.visibility = 'hidden'; });

            const content = document.createElement('div');
            content.className = 'product-package-gifts-item__content';
            const title = document.createElement('p');
            title.className = 'product-package-gifts-item__title';
            title.textContent = `${gift.title || gift.product_title || ''} × ${gift.quantity ?? 1}`;
            content.appendChild(title);
            if (showWorth) {
                const prices = document.createElement('div');
                prices.className = 'product-package-gifts-item__prices';
                const price = document.createElement('span');
                price.textContent = this.formatPrice(0);
                prices.appendChild(price);
                const worth = Number(gift.worth);
                if (Number.isFinite(worth) && worth > 0) {
                    const comparePrice = document.createElement('s');
                    comparePrice.textContent = this.formatPrice(worth);
                    prices.appendChild(comparePrice);
                }
                content.appendChild(prices);
            }
            row.append(image, content);
            return row;
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        new Product();
        new ProductPackageGifts();
        // new Policy();

        onlyLabel();
        // handleQuizEntry();
        window.getProductVariantsLabels = getProductVariantsLabels;

        window.onlyLabel = onlyLabel;
        document.addEventListener('theme:product::switchVariant', () => {
            onlyLabel();
        });
    });
})(jQueryTheme);